/**
 * Shared utilities for ToolDisplay components.
 */

import styles from "./utils.module.css";

/** Safely extract a display string from a value that might be a string, number, or an object with a name property */
export function displayValue(value: unknown): string {
  if (typeof value === "string") return value;
  if (typeof value === "number") return String(value);
  if (value && typeof value === "object" && "name" in value) return String((value as Record<string, unknown>).name);
  return String(value);
}

/** CSS class for the "Show all N items" button — provides hover state */
export const showAllButtonClass = styles.showAllButton;

/** CSS class for inline action links (e.g. "View Float") — provides hover underline */
export const actionLinkClass = styles.actionLink;
